import React, { useCallback } from "react";
import cn from "classnames";
import styles from "./Dropdown.module.scss";
import PortalTarget from "../PortalTarget/PortalTarget";
import Loader from "../Loader";
import { twMerge } from "tailwind-merge";
// Category component that can be mixed with regular options
export const DropdownCategory = ({ name }) => (React.createElement("div", { className: "flex w-full  items-center gap-3", "data-dropdown-category": true },
    React.createElement("div", { className: "h-px w-full bg-separator-color" }),
    React.createElement("div", { className: "typography-small " }, name),
    React.createElement("div", { className: "h-px w-full bg-separator-color" })));
const Dropdown = ({ base, openOnHover, className, anchor, options, closeOnClick = true, showLoaderOnOptionsActions = false, loaderColor, offsetX, offsetY, subPortalRefs, dataCySuffix, alternativeOptionColor, }) => {
    const [open, setOpen] = React.useState(false);
    const handleMouseEnter = useCallback(() => openOnHover && setOpen(true), [openOnHover]);
    const handleMouseLeave = useCallback(() => openOnHover && setOpen(false), [openOnHover]);
    const [isHandlingAction, setIsHandlingAction] = React.useState(false);
    const handleAction = useCallback(async (action) => {
        const actionResult = action();
        if (typeof actionResult?.then === "function") {
            setIsHandlingAction(true);
            try {
                await actionResult;
            }
            finally {
                setIsHandlingAction(false);
            }
        }
    }, []);
    const dataCy = (name) => {
        return dataCySuffix ? `${name}-${dataCySuffix}` : name;
    };
    const dataCyProps = {
        root: dataCy("ukt-dropdown"),
        item: dataCy("ukt-dropdown-item"),
    };
    return (React.createElement(PortalTarget, { isVisible: open, anchor: anchor ?? "bottomRight", portal: {
            offsetY,
            offsetX,
            autofocus: true,
            onClickOutside: () => setOpen(false),
            subPortalRefs: subPortalRefs,
            render: ({ ref, style }) => (React.createElement("div", { onMouseLeave: handleMouseLeave, onMouseEnter: () => setOpen(true), ref: ref, style: style, className: cn("ukt-dropdown", styles.dropdown, className), "data-cy": dataCyProps.root }, Array.isArray(options)
                ? options.map((item, key) => {
                    const isCategoryItem = isCategory(item);
                    return (React.createElement("div", { key: key, className: twMerge(isCategoryItem ? styles.category : styles.item, !isCategoryItem &&
                            alternativeOptionColor &&
                            styles[alternativeOptionColor], !isCategoryItem && "typography-control"), onClick: () => !isCategoryItem && closeOnClick && setOpen(false), "data-cy": `${dataCyProps.item}-${key}` }, !isCategoryItem &&
                        showLoaderOnOptionsActions &&
                        hasOnClick(item)
                        ? React.cloneElement(item, {
                            onClick: () => handleAction(item.props.onClick),
                        })
                        : item));
                })
                : options)),
        }, renderChild: (ref) => {
            return (React.createElement("button", { className: "w-full", ref: ref, style: {
                    cursor: isHandlingAction ? "default" : undefined,
                }, onMouseLeave: handleMouseLeave, onMouseEnter: handleMouseEnter, onClick: () => !isHandlingAction && setOpen(!open), "aria-label": "Open Popup with more options" }, isHandlingAction ? (React.createElement(Loader, { color: loaderColor, className: "pointer-events-none" })) : (base)));
        } }));
};
function hasOnClick(element) {
    if (typeof element !== "object" || element === null)
        return false;
    return "props" in element && typeof element.props.onClick === "function";
}
function isCategory(element) {
    if (typeof element !== "object" || element === null)
        return false;
    if ("type" in element && element.type === DropdownCategory) {
        return true;
    }
    return false;
}
export default Dropdown;
//# sourceMappingURL=Dropdown.js.map